// Central backend API helper.
//
// All backend calls go through apiFetch() so every request carries the active
// language (X-Lang). The backend resolves the language from this header (its
// registry-whitelisted override), which lets a single shared backend serve
// every language — no per-language backend service or hostname routing needed.

// URL of the Python backend.
//
// Whatever the build says, first — every production build sets it, and a dev run
// may too. `npm run start:cs-test` points a local frontend at the staging
// backend so the test groups (and a working sign-in) are there without running
// a backend at all, and this line used to ignore it: dev mode was hard-wired to
// localhost, so the variable travelled into the bundle and was never read.
// Every request went to 127.0.0.1:8080 and the console filled with
// ERR_CONNECTION_REFUSED.
//
// Kde běží backend při vývoji: tam, odkud se načetla stránka.
//
// Natvrdo „127.0.0.1" ukazovalo na VLASTNÍ počítač toho, kdo se dívá. Kdo si
// otevřel vývojový frontend přes lokální IP z jiného stroje, mluvil s backendem,
// který u něj neběží. Na localhostu z toho vyjde totéž co dřív.
function devBackend() {
  try {
    const host = window.location.hostname;
    if (host) return `http://${host}:8080`;
  } catch (e) {
    /* bez okna (testy, SSR) — zbývá výchozí */
  }
  return "http://127.0.0.1:8080";
}

// Unset: the machine serving the page in dev, the shared backend otherwise.
export const SERVER_URL =
  process.env.REACT_APP_SERVER_URL ||
  (process.env.NODE_ENV === "development"
    ? devBackend()
    : "https://backend-dot-prihoriva.ew.r.appspot.com");

// Single source of truth for the language the frontend tells the backend.
// Today: build-time constant (one build per language, REACT_APP_LANGUAGE).
// Future (one unified build for all domains): swap this to derive the language
// from window.location.hostname — every apiFetch caller keeps working unchanged.
export function getLang() {
  return process.env.REACT_APP_LANGUAGE || "cs";
}

// An Authorization header that carries no actual token.
//
// getIdToken() returns null when there is no signed-in user or the refresh did
// not come back, and a caller building the header as `Bearer ${token}` sends the
// literal string "Bearer null". The backend then tries to verify it and logs
// "Wrong number of segments in token: b'null'" — a real-looking auth failure for
// a request that simply had nothing to send. Same 401 either way, so nothing is
// lost by not sending it, and the log stops describing a broken token that never
// existed. Seen three times on 2026-09-01; the value is stripping it in ONE place
// rather than guarding a dozen call sites and the next one somebody writes.
//
// X-Auth-Expected still goes out where the caller sets it, so the backend can
// tell a genuine guest from somebody whose token went astray.
function hasNoToken(value) {
  const v = String(value ?? "").trim();
  return v === "" || v === "Bearer" || v === "Bearer null" || v === "Bearer undefined";
}

// fetch() wrapper that prepends SERVER_URL and injects the X-Lang header,
// preserving any caller-supplied options/headers.
export function apiFetch(path, options = {}) {
  const headers = { ...(options.headers || {}), "X-Lang": getLang() };
  for (const key of Object.keys(headers)) {
    if (key.toLowerCase() === "authorization" && hasNoToken(headers[key])) {
      delete headers[key];
    }
  }
  return fetch(`${SERVER_URL}${path}`, { ...options, headers });
}
